var map = {
	"./sidebar/active/blog.svg": "9b3f",
	"./sidebar/active/chat.svg": "b6fd",
	"./sidebar/active/logistics.svg": "64f2",
	"./sidebar/active/mag.svg": "93a3",
	"./sidebar/active/main.svg": "8aa0",
	"./sidebar/active/offer.svg": "2f4e",
	"./sidebar/active/products.svg": "9d64",
	"./sidebar/active/purchases.svg": "237a",
	"./sidebar/active/salies.svg": "5041",
	"./sidebar/active/shops.svg": "2578",
	"./sidebar/active/staff.svg": "2db3",
	"./sidebar/active/suggestions.svg": "75dd",
	"./sidebar/blog.svg": "0d83",
	"./sidebar/chat.svg": "7877",
	"./sidebar/logistics.svg": "ea6e",
	"./sidebar/mag.svg": "737e",
	"./sidebar/main.svg": "a098",
	"./sidebar/notepad.svg": "db63",
	"./sidebar/offer.svg": "d91a",
	"./sidebar/products.svg": "c676",
	"./sidebar/purchases.svg": "ddf4",
	"./sidebar/salies.svg": "1718",
	"./sidebar/shops.svg": "c8a4",
	"./sidebar/staff.svg": "88fb",
	"./sidebar/suggestions.svg": "a7ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a858";